import React from 'react'
import SEO from '../components/SEO'

export default function NotFound(){
    return (
        <div className="container my-5">
            <SEO title="404 - Page Not Found | 100Eyes Technologies" description="The page you requested was not found. Return to the home page or explore our services and contact us for help." canonical="https://100eyestechnologies.com/404" noIndex={true} />
            <h1>404 Page</h1>
            <p>The page you requested was not found.</p>
        </div>
    )
}
